module.exports = __webpack_public_path__ + "img/es-mb-banner.c7b8bb8c.gif";